<template>
  <div class="guest-editor">
    <el-form ref="form" label-width="100px">
      <el-form-item label="上边距">
        <el-slider v-model="currentItem.style.margin_top" style="padding-left:10px;"></el-slider>
      </el-form-item>
      <el-form-item label="左右边距">
        <el-slider v-model="currentItem.style.padding" style="padding-left:10px;"></el-slider>
      </el-form-item>
      <el-form-item label="左标题">
        <el-input v-model="currentItem.title_left" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="右标题">
        <el-input v-model="currentItem.title_right" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="图片">
        <div class="image">
          <div class="add-btn" v-if="!currentItem.thumb" @click="selectThumb">+</div>
          <img v-if="currentItem.thumb" title="点击更换" :src="currentItem.thumb" @click="selectThumb"/>
        </div>
      </el-form-item>
      <el-form-item label="图片左标题">
        <el-input v-model="currentItem.thumb_title_left" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="图片右标题">
        <el-input v-model="currentItem.thumb_title_right" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="描述">
        <el-input type="textarea" :autosize="{minRows:3}" v-model="currentItem.text" placeholder="请输入内容"></el-input>
      </el-form-item>
    </el-form>
    <upload-img ref="upload" tips-width="900" tips-height="900"></upload-img>
  </div>
</template>
<script>
import UploadImg from '@/components/UploadImg'
export default {
  name: 'guest-editor',
  components: {
    UploadImg
  },
  computed: {
    currentItem () {
      return this.$store.state.page.currentItem
    }
  },
  methods: {
    selectThumb () {
      let list = []
      if (this.currentItem.thumb) {
        list = [this.currentItem.thumb]
      }
      this.$refs.upload.show(list, 'other', 1).then(res => {
        if (res.length) {
          this.currentItem.thumb = res[0]
        }
      }).catch()
    }
  }
}
</script>
<style lang="less" scoped>
.guest-editor {
  .image {
    .add-btn {
      cursor: pointer;
      text-align: center;
      line-height: 50px;
      width: 50px;
      height: 50px;
      border: 1px dashed #cccccc;
    }
    img {
      cursor: pointer;
      height: 50px;
      width: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PageEditor/editors/guestEditor.vue